import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TokenService } from '../../../services/token/token.service';

@Component({
  selector: 'cm-login-user',
  template: '',
})
export class LoginUserComponent implements OnInit {
  constructor(private tokenService: TokenService, private router: Router, private arouter: ActivatedRoute) {}

  ngOnInit() {
    this.arouter.params.subscribe(params => {
      const token = params['token'];
      const role = params['role'];
      const handleToken = () => {
        if (role === 'professional') {
          this.router.navigate(['/professional']);
        } else if (role === 'organization') {
          this.router.navigate([`/organization/`]);
        } else if (role === 'imposer') {
          this.router.navigate([`/imposer/`]);
        }
      };

      const handleError = () => {
        this.router.navigate(['/organization/']);
      };

      this.tokenService.forceLoginUserByToken(token).subscribe(handleToken, handleError);
    });
  }
}
